export default {
      id: "ic_check_white-usage",
      viewBox: "0 0 12 10",
      url: "/" + "images/icons.3.109.2.svg#ic_check_white-usage",
      toString: function () {
        return this.url;
      }
    }